import { eur } from "@/lib/api";
import { Card } from "@/components/common";
import { pct, signCls, signed } from "./helpers";

export default function Scenarios({ d }) {
  const t = d.totals, amount = d.target.amount;
  const items = [
    ["prud", "Prudente (solo confermato − cancellazioni, variabili +10%)", t.entrate_prud, t.netto_prud, "border-rose-200 bg-rose-50/40"],
    ["base", "Base (confermato − cancellazioni + pickup)", null, t.netto_base, "border-sky-200 bg-sky-50/40"],
    ["ott", "Ottimistico (pickup ×120%, senza cancellazioni)", t.entrate_ott, t.netto_ott, "border-emerald-200 bg-emerald-50/40"],
  ];
  return (
    <Card className="p-4" data-testid="pv-scenarios">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <div className="text-sm font-semibold text-slate-700">Scenari di fine anno</div>
        <div className="text-xs text-slate-500" data-testid="pv-scenario-range">Forbice netto: <b className="tabular text-slate-800">{eur(t.netto_prud)} → {eur(t.netto_ott)}</b></div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {items.map(([k, label, lordo, netto, cls]) => (
          <div key={k} className={`rounded-md border p-3 ${cls}`} data-testid={`pv-scenario-${k}`}>
            <div className="text-[11px] uppercase tracking-wide text-slate-500">{label}</div>
            <div className={`text-xl font-bold tabular mt-1 ${signCls(netto)}`}>{eur(netto)}</div>
            {lordo != null && <div className="text-[11px] text-slate-500">lordo {eur(lordo)}</div>}
            {amount != null && <div className={`text-[11px] font-semibold mt-0.5 ${signCls(netto - amount)}`}>vs obiettivo {signed(netto - amount)}</div>}
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-400 mt-2">Usa i pulsanti Prudente / Base / Ottimistico in alto per aggiornare card, tabella e grafici sullo scenario scelto. Mesi chiusi e in corso restano reali.</p>
    </Card>
  );
}
